
import DialogESOProgramEditInfo from "@/components/dialogs/DialogESOProgramEditInfo.vue";
import DialogESOCohortCreate from "@/components/dialogs/DialogESOCohortCreate";
import DialogESOCohortEdit from "@/components/dialogs/DialogESOCohortEdit";

import { mapActions } from "vuex";

export default {
  name: "CardViewESOProgram",
  components: {
    DialogESOProgramEditInfo,
    DialogESOCohortCreate,
    DialogESOCohortEdit,
  },
  data() {
    return {
      isShowingCohort: false,
      actionMenus: [
        { title: this.$t("edit"), action: 1, icon: "mdi-pencil" },
        { title: this.$t("delete"), action: 2, icon: "mdi-delete" },
      ],
    };
  },
  props: {
    expanded: Boolean,
    to: { type: String, default: "" },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    esoId() {
      return this.$route.params.esoId;
    },
  },
  mounted() {
    if (this.expanded) {
      this.isShowingCohort = true;
    }
  },
  methods: {
    ...mapActions("eso-program", {
      getProgram: "get",
    }),
    handleOpenEditProgramDialog(item) {
      this.$refs.dialogEditProgramInfo.openForm(item);
    },
    handleOpenCreateCohortDialog(item) {
      this.$refs.dialogCreateCohortInfo.openForm({
        program: item.id,
        eso: this.esoId,
      });
    },
    handleOpenEditCohortDialog(item) {
      this.$refs.dialogEditCohortInfo.openForm({ ...item, eso: this.esoId });
    },
    handleDeleteProgram() {
      this.$swal
        .fire({
          type: "info",
          text: this.$t("startup.page.question.delete"),
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonText: this.$t("dialog.cancel"),
          confirmButtonText: this.$t("dialog.yes"),
          reverseButtons: true,
        })
        .then(({ value }) => {
          if (!value) return;

          let uri = `/api/v1/eso-program/${this.item.id}/`;

          this.$axios
            .delete(uri)
            .then((response) => {
              const _title = this.$t("common.deleted_successful");
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire("", _title, "success");
              this.getProgram({ params: { eso: this.esoId } });
            })
            .catch((error) => {
              const _title = this.$t("common.error");
              this.$swal.fire(_title, error.toString(), "error");
            });
        });
    },

    handleDeleteCohort(cohortId) {
      this.$swal
        .fire({
          type: "info",
          text: this.$t("startup.page.question.delete"),
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonText: this.$t("dialog.cancel"),
          confirmButtonText: this.$t("dialog.yes"),
          reverseButtons: true,
        })
        .then(({ value }) => {
          if (!value) return;

          let uri = `/api/v1/eso-cohort/${cohortId}/`;

          this.$axios
            .delete(uri)
            .then((response) => {
              const _title = this.$t("common.deleted_successful");
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire("", _title, "success");
              this.getProgram({ params: { eso: this.esoId } });
            })
            .catch((error) => {
              const _title = this.$t("common.error");
              this.$swal.fire(_title, error.toString(), "error");
            });
        });
    },

    viewCohortDetail(cohort) {
      console.log("viewCohortDetail", cohort.program_display.id);

      this.$router.push(`/program/${cohort.program_display.id}`);
      // this.$router.push({path:`/program`, params: {id: cohort.program_display.id}});
      // this.$router.push({path: '/program', params: {id: "278"}});

      // if(cohort?.program_display)  this.$router.push({path: '/program', params: {id: cohort.program_display.id}});
    },
  },
};
